import { render, staticRenderFns } from "./CompoundCard.vue?vue&type=template&id=c63f2920&scoped=true&"
import script from "./CompoundCard.vue?vue&type=script&lang=js&"
export * from "./CompoundCard.vue?vue&type=script&lang=js&"
import style0 from "./CompoundCard.vue?vue&type=style&index=0&id=c63f2920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63f2920",
  null
  
)

export default component.exports